import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.state = {
      propertyId: props.params.propertyId
    }
  }

  render() {
    const { propertyId } = this.state
    const { imgList } = this.store

    const header = [
      <Link to={'/localMerchant/case'}>发布案例</Link>,
      '查看样例'
    ]

    return (
      <HeaderView header={header} title="优秀案例范例">
        <div style={{ display: 'flex', margin: '30px 0 150px 20px' }}>
          <div style={{ marginRight: 65 }}>
            {imgList[+propertyId].map(el => (
              <img style={{ display: 'block', width: 375 }} src={el} />
            ))}
          </div>
        </div>
      </HeaderView>
    )
  }
}
